export default __webpack_public_path__ + "static/media/question.050569cc.jpg";